"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = identity;
function identity(x) {
  return x;
}


//////////////////
// WEBPACK FOOTER
// ./~/@vx/axis/build/utils/identity.js
// module id = ./node_modules/@vx/axis/build/utils/identity.js
// module chunks = 2345137460201621000 9249036036638527000 16304781003358073000